import React from "react";
import Modal from "./Modal.tsx";
import { Controller } from "react-hook-form";
import SelectField from "../Forms/SelectField.js";
import TextAreaField from "../Forms/TextAreaField.js";

export const MedicationAdministrationModal = ({
  isOpen,
  onClose,
  onSubmit,
  control,
  errors,
  isLoading,
  selectedCount,
  medicationType = "Medication",
}) => {
  const administrationOptions = [
    { value: "Administered", label: "Administered" },
    { value: "Prompted", label: "Prompted" },
    { value: "Declined", label: "Declined" },
    { value: "Assisted", label: "Assisted" },
    { value: "Required", label: "Required" },
    { value: "Not Applicable", label: "Not Applicable" },
  ];

  return (
    <Modal
      title={`Administer ${selectedCount} ${medicationType}${
        selectedCount > 1 ? "s" : ""
      }`}
      size="md"
      onCancel={onClose}
      isOpen={isOpen}
    >
      <form onSubmit={onSubmit}>
        <SelectField
          control={control}
          name="administrationType"
          label="Administration type"
          error={errors.administrationType?.message}
          options={administrationOptions}
          required
        />

        <div className="form__group">
          <label>
            Signature <span className="required">*</span>
          </label>
          <Controller
            name="signature"
            control={control}
            render={({ field }) => (
              <input
                {...field}
                type="text"
                className={`form__input ${
                  errors.signature ? "form__input--error" : ""
                }`}
                placeholder="Enter your full name"
              />
            )}
          />
          {errors.signature && (
            <div className="form__error">{errors.signature.message}</div>
          )}
        </div>

        <TextAreaField
          name="notes"
          control={control}
          label="Additional Notes"
          error={errors.notes?.message}
          placeholder="Any additional observations or notes..."
          required
        />

        <div className="modal__actions">
          <button
            type="button"
            className="btn btn--secondary"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn__primary"
            disabled={isLoading}
          >
            {isLoading ? "Recording..." : "Record Administration"}
          </button>
        </div>
      </form>
    </Modal>
  );
};
